/* eslint-disable */
// Auto-generated WebSocket client from AsyncAPI spec
// DO NOT EDIT MANUALLY - Run 'npm run generate:socket-client' to regenerate
import { Socket, io } from "socket.io-client";
import type {
  AgentWorkingEventDto,
  ConnectedPayload,
  ConversationDeletedDto,
  ConversationEventDto,
  ConversationUpdateEventDto,
  DisconnectedPayload,
  ErrorPayload,
  IncomingWebSocketEvent,
  MessageEventDto,
  MessageReadEventDto,
  NotificationBadgeDto,
  NotificationBatchDto,
  NotificationEventDto,
  OutgoingWebSocketEvent,
  PlanningVersionApprovedEventDto,
  PlanningVersionCreatedEventDto,
  PlanningVersionDeletedEventDto,
  PlanningVersionRevertedEventDto,
  PlanningVersionUpdatedEventDto,
  PongDto,
  PresenceEventDto,
  ShiftEventDto,
  SolverCompletedEventDto,
  SolverFailedEventDto,
  SolverProgressEventDto,
  SuggestedActionEventDto,
  TypingEventDto,
} from "./types";

export interface WebSocketClientOptions {
  url?: string;
  token?: string;
  autoConnect?: boolean;
  reconnection?: boolean;
  reconnectionAttempts?: number;
  reconnectionDelay?: number;
}

export type EventHandler<T = any> = (data: T) => void;

export class WebSocketClient {
  private socket: Socket | null = null;
  private listeners: Map<string, Set<EventHandler>> = new Map();
  private options: WebSocketClientOptions;

  constructor(options: WebSocketClientOptions = {}) {
    this.options = {
      url: (import.meta.env?.VITE_WS_URL as string | undefined) || "wss://api.heyboomer.localhost",
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      ...options,
    };

    if (this.options.autoConnect) {
      this.connect();
    }
  }

  connect(): void {
    if (this.socket?.connected) {
      return;
    }

    const wsUrl = this.options.url!.replace("https:", "wss:").replace("http:", "ws:");

    this.socket = io(`${wsUrl}/admin`, {
      transports: ["polling", "websocket"],
      withCredentials: true,
      auth: this.options.token ? { token: this.options.token } : undefined,
      reconnection: this.options.reconnection,
      reconnectionAttempts: this.options.reconnectionAttempts,
      reconnectionDelay: this.options.reconnectionDelay,
    });

    this.setupEventHandlers();
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  private setupEventHandlers(): void {
    if (!this.socket) return;

    // Connection events
    this.socket.on("connect", () => {
      this.emit("connected", { socketId: this.socket!.id, userId: "" });
    });

    this.socket.on("disconnect", (reason: string) => {
      this.emit("disconnected", { socketId: this.socket!.id, reason });
    });

    this.socket.on("error", (error: Error) => {
      this.emit("error", { message: error.message || "Unknown error", error: error.toString() });
    });

    // Generated event handlers
    this.socket.on("typing:start", (data: TypingEventDto) => {
      this.emit("typing:start", data);
    });

    this.socket.on("typing:stop", (data: TypingEventDto) => {
      this.emit("typing:stop", data);
    });

    this.socket.on("message:new", (data: MessageEventDto) => {
      this.emit("message:new", data);
    });

    this.socket.on("message:read", (data: MessageReadEventDto) => {
      this.emit("message:read", data);
    });

    this.socket.on("message:updated", (data: MessageEventDto) => {
      this.emit("message:updated", data);
    });

    this.socket.on("conversation:updated", (data: ConversationUpdateEventDto) => {
      this.emit("conversation:updated", data);
    });

    this.socket.on("agent:working", (data: AgentWorkingEventDto) => {
      this.emit("agent:working", data);
    });

    this.socket.on("conversation:new", (data: ConversationEventDto) => {
      console.log("conversation:new", data);
      this.emit("conversation:new", data);
    });

    this.socket.on("conversation:deleted", (data: ConversationDeletedDto) => {
      this.emit("conversation:deleted", data);
    });

    this.socket.on("notification:new", (data: NotificationEventDto) => {
      this.emit("notification:new", data);
    });

    this.socket.on("notification:badge", (data: NotificationBadgeDto) => {
      this.emit("notification:badge", data);
    });

    this.socket.on("notification:batch", (data: NotificationBatchDto) => {
      this.emit("notification:batch", data);
    });

    this.socket.on("presence:update", (data: PresenceEventDto) => {
      this.emit("presence:update", data);
    });

    this.socket.on("suggested-action:new", (data: SuggestedActionEventDto) => {
      this.emit("suggested-action:new", data);
    });

    this.socket.on("shift:changed", (data: ShiftEventDto) => {
      this.emit("shift:changed", data);
    });

    this.socket.on("shifts:changed", (data: ShiftEventDto) => {
      this.emit("shifts:changed", data);
    });

    this.socket.on("planning:version-created", (data: PlanningVersionCreatedEventDto) => {
      this.emit("planning:version-created", data);
    });

    this.socket.on("planning:version-updated", (data: PlanningVersionUpdatedEventDto) => {
      this.emit("planning:version-updated", data);
    });

    this.socket.on("planning:version-approved", (data: PlanningVersionApprovedEventDto) => {
      this.emit("planning:version-approved", data);
    });

    this.socket.on("planning:version-reverted", (data: PlanningVersionRevertedEventDto) => {
      this.emit("planning:version-reverted", data);
    });

    this.socket.on("planning:version-deleted", (data: PlanningVersionDeletedEventDto) => {
      this.emit("planning:version-deleted", data);
    });

    this.socket.on("connected", (data: ConnectedPayload) => {
      this.emit("connected", data);
    });

    this.socket.on("disconnected", (data: DisconnectedPayload) => {
      this.emit("disconnected", data);
    });

    this.socket.on("error", (data: ErrorPayload) => {
      this.emit("error", data);
    });

    this.socket.on("pong", (data: PongDto) => {
      this.emit("pong", data);
    });

    this.socket.on("solver:progress", (data: SolverProgressEventDto) => {
      this.emit("solver:progress", data);
    });

    this.socket.on("solver:completed", (data: SolverCompletedEventDto) => {
      this.emit("solver:completed", data);
    });

    this.socket.on("solver:failed", (data: SolverFailedEventDto) => {
      this.emit("solver:failed", data);
    });
  }

  // Send events
  send(event: OutgoingWebSocketEvent): void {
    if (!this.socket?.connected) {
      return;
    }

    this.socket.emit(event.type, event.payload);
  }

  // Convenience methods for sending specific events
  conversationJoin(conversationId: string): void {
    this.send({ type: "conversation:join", payload: { conversationId } });
  }

  conversationLeave(conversationId: string): void {
    this.send({ type: "conversation:leave", payload: { conversationId } });
  }

  startTyping(conversationId: string, userId: string, displayName: string): void {
    this.send({
      type: "typing:start",
      payload: { conversationId, userId, displayName } as TypingEventDto,
    });
  }

  stopTyping(conversationId: string, userId: string, displayName: string): void {
    this.send({
      type: "typing:stop",
      payload: { conversationId, userId, displayName } as TypingEventDto,
    });
  }

  setPresenceAway(): void {
    this.send({ type: "presence:away", payload: { status: "away" } });
  }

  setPresenceOnline(): void {
    this.send({ type: "presence:online", payload: { status: "online" } });
  }

  ping(): void {
    this.send({ type: "ping", payload: { timestamp: new Date().toISOString() } });
  }

  // Event listeners with proper typing
  on<T extends IncomingWebSocketEvent["type"]>(
    event: T,
    handler: EventHandler<Extract<IncomingWebSocketEvent, { type: T }>["payload"]>,
  ): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(handler as EventHandler);
  }

  off<T extends IncomingWebSocketEvent["type"]>(
    event: T,
    handler: EventHandler<Extract<IncomingWebSocketEvent, { type: T }>["payload"]>,
  ): void {
    const handlers = this.listeners.get(event);
    if (handlers) {
      handlers.delete(handler as EventHandler);
    }
  }

  private emit(event: string, data: any): void {
    const handlers = this.listeners.get(event);
    if (handlers) {
      handlers.forEach((handler) => handler(data));
    }
  }

  // Getters
  get isConnected(): boolean {
    return this.socket?.connected || false;
  }

  get socketId(): string | undefined {
    return this.socket?.id;
  }
}

// Singleton instance
let wsClient: WebSocketClient | null = null;

export function getWebSocketClient(options?: WebSocketClientOptions): WebSocketClient {
  if (!wsClient) {
    wsClient = new WebSocketClient(options);
  }
  return wsClient;
}

export function disconnectWebSocket(): void {
  if (wsClient) {
    wsClient.disconnect();
    wsClient = null;
  }
}
